"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
class ApiError {
    constructor() {
        this.message = null;
        this.code = null;
        this.cause = null;
        this.httpCode = null;
        this.stringify = () => {
            const parts = [];
            if (this.code) {
                parts.push(`[${this.code}]`);
            }
            if (this.message) {
                parts.push(this.message);
            }
            const rootCause = this.getRootCause(this.cause);
            if (rootCause) {
                parts.push('caused by');
                if (rootCause.code) {
                    parts.push(`[${rootCause.code}]`);
                }
                if (rootCause.message) {
                    parts.push(rootCause.message);
                }
            }
            if (!parts.length && this.httpCode) {
                parts.push(this.httpCode.toString());
            }
            return parts.join(' ');
        };
        this.getRootCause = (error) => {
            if (!error) {
                return null;
            }
            if (error.cause) {
                return this.getRootCause(error.cause);
            }
            return error;
        };
    }
    get rootCause() {
        return this.getRootCause(this.cause);
    }
}
exports.ApiError = ApiError;
ApiError.from = (dto, httpCode) => {
    const model = new ApiError();
    model.message = dto.message ?? null;
    model.code = dto.code;
    model.cause = dto.cause ?? null;
    model.httpCode = httpCode;
    return model;
};
